{"id":"Cart.TipBox","prefabs":{"default":{"children":[{"component":"Cart.TipBox","options":"options:*"}]}}}